<div [innerHTML]="info" class="extract-info"></div>
